import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, Table, TableBody, TableCell, TableContainer, TableRow, Typography} from '@mui/material';

import {bodyPdf, pdfH1} from './styles';
import {EmpionPaper} from '../../../components/EmpionPaper/EmpionPaper';
import {CultureAnalysisPdfContext} from '../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {orangeColors} from '../../../layouts/theme/designSystem';

export const TableOfContents = () => {
  const {t} = useTranslation('pdfDomain', {keyPrefix: 'tableOfContents'});

  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return <></>;
  }

  const empionRecommendations = data.empionRecommendations;

  function createData(name: string, pageNumber: number) {
    return {name: t(name), pageNumber: String(pageNumber).padStart(2, '0')};
  }

  const rows = [
    createData('analysisGuide', 5),
    createData('executiveSummary', 9),
    createData('culturalFoundation', 10),
    createData('dreamEmployerAnalysis', 14),
    createData('satisfactionAnalysis', 18),
    ...(empionRecommendations && empionRecommendations.length > 0 ? [createData('recommendedActions', 26)] : []),
  ];

  return (
    <Grid container justifyContent={'center'}>
      <Box height={'180px'} width={'100%'} p={5}>
        <Typography variant='h1' sx={pdfH1}>
          {t('title')}
        </Typography>
      </Box>

      <Grid item mt={3}>
        <TableContainer
          component={EmpionPaper}
          sx={{backgroundColor: orangeColors[5], borderRadius: '16px', border: `1px solid ${orangeColors[3]}`}}
        >
          <Table sx={{minWidth: 650}} aria-label='simple table'>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.name}>
                  <TableCell
                    sx={{
                      '&.MuiTableCell-root': {
                        borderBottom: `1px solid ${orangeColors[3]}`,
                      },
                    }}
                  >
                    <Typography sx={bodyPdf}>{row.name}</Typography>
                  </TableCell>
                  <TableCell
                    align='right'
                    sx={{
                      '&.MuiTableCell-root': {
                        borderBottom: `1px solid ${orangeColors[3]}`,
                      },
                    }}
                  >
                    <Typography sx={bodyPdf}>
                      {t('page')} {row.pageNumber}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
